module.exports = __webpack_public_path__ + "img/orange-circle-table-6.217541b1.png";